//LOADING
export const TOGGLE_LOADING = 'TOGGLE_LOADING'; 
export const JOURNEY_LISTING = 'JOURNEY_LISTING'; 
export const UNAUTHORIZED_JOURNEY = 'UNAUTHORIZED_JOURNEY'; 
